import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useSelector } from 'react-redux';
import CommonTable from '../../common/components/CommonTable';
import VehicleBidsLaunchTableRow from './VehicleBidsLaunchTableRow';
import VehicleAddBidForm from './VehicleAddBidForm';
import CommonLoader from '../../common/components/CommonLoader';

const headers = [
  {
    label: 'Buyer',
  },
  {
    label: 'Buyer Location',
  },
  {
    label: 'Bidder',
  },
  {
    label: 'Bid',
  },
  {
    label: 'Date',
  },
  {
    label: 'Actions',
    className: 'text-right',
  },
];

let removeBid;

function VehicleBidsLaunchTable({ data, includeForm, removeItemHandler }) {
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [sortedData, setSortedData] = useState([]);

  const loaderStatus = useSelector((state) => state.bids.get('loaderStatus'));

  useEffect(() => {
    if (data.items) {
      setSortedData(
        data.items.sort((a, b) => {
          if (a.amountInPence !== b.amountInPence) {
            return b.amountInPence - a.amountInPence;
          }
          return Date.parse(a.createdOn) - Date.parse(b.createdOn);
        }),
      );
    }
  }, [data.items]);

  const showRemoveItemAlert = (bid) => {
    removeBid = bid;
    setIsAlertVisible(true);
  };

  return (
    <>
      <Row>
        <Col xs="12">
          <CommonLoader status={loaderStatus}>
            <CommonTable
              rowComponent={VehicleBidsLaunchTableRow}
              rowComponentProps={{ showRemoveItemAlert }}
              data={{ items: sortedData, total: data?.totalItems }}
              headers={headers}
              pagination={false}
              hasRowPointer={false}
            />
          </CommonLoader>
        </Col>
        <SweetAlert
          danger
          showCancel={false}
          showConfirm={false}
          show={isAlertVisible}
          title="Warning!"
          onConfirm={() => {
            setIsAlertVisible(false);
            removeItemHandler(removeBid);
          }}
          onCancel={() => setIsAlertVisible(false)}
        >
          {(renderProps) => (
            <div>
              <p>Are you sure to remove this bid?</p>
              <div className="d-flex justify-content-center gap-2 mt-3">
                <Button className="rounded-pill btn-soft-primary" onClick={renderProps.cancel}>
                  Cancel
                </Button>
                <Button className="rounded-pill btn-danger" onClick={renderProps.confirm}>
                  Yes, Remove
                </Button>
              </div>
            </div>
          )}
        </SweetAlert>
      </Row>
      {includeForm ? <VehicleAddBidForm /> : null}
    </>
  );
}

VehicleBidsLaunchTable.propTypes = {
  data: PropTypes.array.isRequired,
};

export default VehicleBidsLaunchTable;
